import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_VALIDATE_NON_NATIONAL_EXAM_VACANCY } from '../../constants/apiUrls';

interface Input {
  uuid: string;
  enabled: boolean;
  onSuccess?: () => void;
  onError?: () => void;
}

export const useGetValidateNonNationalExamVacancy = ({
  uuid,
  onSuccess,
  onError,
  enabled,
}: Input) => {
  const getValidateNonNationalExamVacancy = async () => {
    const res = await axiosClient.get(GET_VALIDATE_NON_NATIONAL_EXAM_VACANCY(uuid));
    return res.data;
  };

  return useCustomQuery('', getValidateNonNationalExamVacancy, {
    onSuccess,
    onError,
    enabled,
  });
};
